import { styled } from '@linaria/react';
import { Stack, breakpoints } from '@spaceshipapp/cambridge';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 72rem;
  align-self: center;
  padding: 1.5rem 0 5.5rem 0;

  > *:not(:first-child) {
    margin-top: 1rem;
  }

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;

    > *:not(:first-child) {
      margin-top: 0;
      margin-left: 1.5rem;
    }
  }
`;

export const LeftStack = styled(Stack)`
  flex-basis: 65%;
  flex-grow: 1;
`;

export const RightStack = styled(Stack)`
  flex-basis: 35%;
  flex-grow: 1;
`;

export const Main = styled.main`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`;
